module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"revenue_data_text":"Revenue Overview"},"zn":{"revenue_data_text":"收益总览"}}')
  delete Component.options._Ctor
}
